import { render } from "./collage.vue?vue&type=template&id=55899621&scoped=true"
import script from "./collage.vue?vue&type=script&lang=js"
export * from "./collage.vue?vue&type=script&lang=js"

import "./collage.vue?vue&type=style&index=0&id=55899621&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55899621"]])

export default __exports__